var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"sneaky-element-inner\"><ng-transclude></ng-transclude></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/od-sneaky-element.jade
 ** module id = 804
 ** module chunks = 0 1 3 4 5 6
 **/